import { useContext, useMemo } from "react";
import contextBabylon from "../../../../context/index.js";
export const useDestinationDefaultValue = (destination)=>{
    const { Market  } = useContext(contextBabylon);
    const destinationDefaultValue = useMemo(()=>{
        if (!destination?.value || !destination?.type) return;
        const { id , value , text , type  } = destination;
        return {
            id: id ?? `${type}-${Market?.toUpperCase()}-${value}`,
            text,
            type,
            value
        };
    }, [
        Market,
        destination
    ]);
    return destinationDefaultValue;
};
export default useDestinationDefaultValue;

//# sourceMappingURL=useDestinationDefaultValue.js.map